module.exports = __webpack_public_path__ + "static/media/C.f06acee9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/C.svg
// module id = 410
// module chunks = 0